import { queryOptions } from "@tanstack/react-query"
import { GatedSessionDetailsPOSTRequest } from "ipctg-inflow-types/InFlowGatedAPI"

import api from "@/utilities/api"

import { GatedSessionDetailsError } from "@/utilities/expectedErrors"

import { SESSION_BASE_KEY, SESSION_DETAILS_BASE_KEY } from "./keys"

export const sessionDetailsQueryOptions = (
  args: GatedSessionDetailsPOSTRequest
) => {
  return queryOptions({
    queryKey: [SESSION_BASE_KEY, args.sessionID, SESSION_DETAILS_BASE_KEY],
    queryFn: async () => {
      const rsp = await api.sessionDetails.POST(args)
      if ("failReason" in rsp) {
        throw new GatedSessionDetailsError(rsp.failReason)
      }
      return rsp
    },
    retry: false,
  })
}
